/** The dividend in dollars as a small table: what it is now and under each choice (a share, a quarter). */
import { formatQuarterlyUsd, type dividendRows } from "./dividendLine";
import { GxTable, type GxColumn } from "../theme/GxTable";
import { figure } from "../theme/figures";

const COLUMNS: readonly GxColumn[] = [{ key: "choice", label: "Choice" }, { key: "amount", label: "A quarter, $", kind: "number" }, { key: "year", label: "Four quarters, $", kind: "number" }];

export function DividendTable({ rows }: { readonly rows: ReturnType<typeof dividendRows> }) {
  if (rows === null) return null;
  const cap = (t: string) => `${t.charAt(0).toUpperCase()}${t.slice(1)}`;
  return (
    <div className="gx-decide-divtable">
      <GxTable
        caption="Dividend a share, a quarter" columns={COLUMNS} dense testId="decide.dividend.dollars"
        rows={[{ key: "now", cells: { choice: "Now", amount: formatQuarterlyUsd(rows.nowUsdPerShare), year: figure(rows.nowAnnualUsd, "usdPerShare") } }, ...rows.rows.map((r) => ({ key: r.label, cells: { choice: cap(r.label), amount: formatQuarterlyUsd(r.usdPerShare), year: figure(r.annualUsd, "usdPerShare") } }))]}
      />
      <p className="gx-small gx-muted">The four-quarter figure assumes the same declaration each quarter, as the schedule pays it; a hold on the payout would change it.</p>
    </div>
  );
}
